import { render, staticRenderFns } from "./Ideas.vue?vue&type=template&id=3a174f2f"
import script from "./Ideas.vue?vue&type=script&lang=js"
export * from "./Ideas.vue?vue&type=script&lang=js"
import style0 from "./Ideas.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports